export const selectAlertInfo = state => state.alert.info;
